<template>
  <div class="generic-delete-modal py-3 px-8">
    <div class="text md:max-w-xs mb-5 text-center">
      Are you sure you want to delete this {{ entityName }}?
    </div>
    <div class="buttons-container text-center">
      <bdg-button
        class="ghost has-icon no-min-width mr-3 uppercase"
        @click.native="closeModal"
      >
        Cancel
      </bdg-button>
      <bdg-button class="no-min-width uppercase" @click.native="deleteFunction">
        Delete
      </bdg-button>
    </div>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";

export default {
  name: "GenericDeleteModal",
  components: { BdgButton },
  props: {
    entityName: {
      type: String,
      required: true
    },
    deleteFunction: {
      type: Function,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$store.commit("resetConfirmationModalParams");
    }
  }
};
</script>
